import { render, staticRenderFns } from "./DataSetTable.vue?vue&type=template&id=d81f42d6&scoped=true"
import script from "./DataSetTable.vue?vue&type=script&lang=js"
export * from "./DataSetTable.vue?vue&type=script&lang=js"
import style0 from "./DataSetTable.vue?vue&type=style&index=0&id=d81f42d6&prod&scoped=true&lang=css"
import style1 from "./DataSetTable.vue?vue&type=style&index=1&id=d81f42d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81f42d6",
  null
  
)

export default component.exports